import { render, staticRenderFns } from "./QueryHistory.vue?vue&type=template&id=40779d7b&scoped=true&"
import script from "./QueryHistory.vue?vue&type=script&lang=js&"
export * from "./QueryHistory.vue?vue&type=script&lang=js&"
import style0 from "./QueryHistory.vue?vue&type=style&index=0&id=40779d7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40779d7b",
  null
  
)

export default component.exports